<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" :stroke="colour" class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>
</template>

<script>
export default {
  props: ['colour']
}
</script>



// WEBPACK FOOTER //
// src/components/IconArrow.vue